import axios from "axios";

export default {
    state: {
        faqList: [],
    },
    mutations: {
        setFaq(state, data) {
            state.faqList = data.sort((a,b) => a.order - b.order);
        },
    },
    actions: {
        loadFaq({ commit }) {
            axios
                .get(process.env.VUE_APP_DABURL + `api/Faq`)
                .then((response) => {
                    if (response.data) {
                        commit("setFaq", response.data);
                    }
                })
                .catch((error) => {
                    this._vm.flashMessage.error({
                        title: "Die FAQ-Frage konnten nicht geladen werden.",
                        message: error
                    });
                });
        },
    }
}